<sk-generic-card *ngIf="content" [cssCustomHeight]="'unset'" [cssContentPadding]="'0'" [style.padding]="'0'" [hideImage]="true" #sideMenuCard [leftBorder]="true">
  <sk-side-menu-section *ngFor="let rootCategory of content; let idx = index" [rootCategoryIndex]="idx" [rootCategory]="rootCategory"></sk-side-menu-section>
</sk-generic-card>
